import React from 'react';
import './InstructionCard.scss';

/** @import { InstructionCardProps } from './InstructionCardTypes' */
export const InstructionCard = (/** @type {InstructionCardProps} */ { label, value }) => (
    <div className={"instructionItem"}>
        <div className={"label"}>{label}</div>
        <div className={"value"}>{value}</div>
        <div> <br/></div>
    </div>
);